import React from "react";
import './stylesComponent/piepagina.css';
import { RiTwitterXFill } from "react-icons/ri";
import { FaInstagram } from "react-icons/fa6";
import { useState, useEffect } from "react";
import { TiSocialFacebookCircular } from "react-icons/ti";
import { FaCcMastercard } from "react-icons/fa";
import { FaCcPaypal } from "react-icons/fa6";
import { RiVisaFill } from "react-icons/ri";
import {Link} from 'react-router-dom';
import { ComponerMensajeDialog } from '../Mensajes';

import { IoIosPricetag } from "react-icons/io";
import { IoMdSearch } from "react-icons/io";
import { GiBuyCard } from "react-icons/gi";
import { MdOutlineMessage } from "react-icons/md";
import { FaTools } from "react-icons/fa";
import Swal from 'sweetalert2';

import $ from "jquery";

const PaginaEstatica = ({ title, children }) => (
  <div className="static-page">
    <h1>{title}</h1>
    <div className="content">{children}</div>
  </div>
);

export const QuienesSomos = () => (
  <PaginaEstatica>
    <div className="principalEstatico">
        <h1>¿Quiénes Somos?</h1>
        <p><strong>App-Formación</strong> nace en 2025 con un único propósito: <strong>acercar la formación de calidad a cualquier persona, en cualquier lugar</strong>. Somos un equipo multidisciplinar apasionado por la enseñanza online y convencido de que el aprendizaje continuo es la clave para el desarrollo personal y profesional.</p>

        <h2>Nuestra misión</h2>
        <ul>
        <li>Facilitar el acceso a cursos y clases impartidos por profesionales expertos.</li>
        <li>Ofrecer una plataforma intuitiva, flexible y segura.</li>
        <li>Fomentar una comunidad activa donde alumnos y tutores se retroalimenten.</li>
        </ul>

        <h2>Nuestra visión</h2>
        <p>Convertirnos en la referencia en formación digital en habla hispana, impulsando el talento y la innovación.</p>

        <h2>Nuestros valores</h2>
        <ul>
        <li><strong>Calidad:</strong> todos nuestros contenidos pasan un riguroso proceso de selección y revisión.</li>
        <li><strong>Transparencia:</strong> precios claros, sin letra pequeña; políticas sencillas y justas.</li>
        <li><strong>Innovación:</strong> incorporamos metodologías activas y herramientas de vanguardia.</li>
        <li><strong>Cercanía:</strong> te apoyamos en tu recorrido formativo con atención personalizada.</li>
        </ul>

        <h2>Trayectoria y logros</h2>
        <ul>
        <li>Más de <strong>150 alumnos</strong> formados en el primer año.</li>
        <li>Colaboraciones con profesionales y entidades de prestigio.</li>
        <li>Comunidad activa de estudiantes, con foros y eventos online semanales.</li>
        </ul>
    </div>
  </PaginaEstatica>
);

export const PlanesPrecios = () => (
  <PaginaEstatica>
    <div className="principalEstatico">
        <h1>Planes y Precios</h1>
        <h2>Elige tu tipo de cuenta</h2>
        <div className="containerEstatico">  
            <div className="rowEstatico">
                <div className="leftEst">
                    <h3 className="tipoEstatico">Cliente</h3>
                    <ul style={{listStyle: 'none', paddingTop: '15px'}}>
                        <li><IoIosPricetag /> Cuenta Gratuita</li>
                        <li><IoMdSearch /> Explora el contenido de los tutores registrados en la web</li>
                        <li><GiBuyCard /> Compra el contenido o inscribete a las clases que más se adecuen a tus necesidades</li>
                        <li><MdOutlineMessage /> Comunicate con los tutores en caso de duda, escribe y lee reseñas en contenido</li>
                    </ul>
                </div>
                <div className="rightEstatico">
                    <h3 className="tipoEstatico">Tutor</h3>
                    <ul style={{listStyle: 'none', paddingTop: '15px'}}>
                        <li><GiBuyCard />Empieza a vender tus conocimientos y habilidades y crea un negocio rentable</li>
                        <li><IoIosPricetag /> Primer mes gratuito y puedes cancelar cuando desees</li>
                        <li><FaTools /> Todas las herramientas necesarias para monetizar tu contenido</li>
                    </ul>
                    <h3 style={{ paddingTop: '55px' }}><IoIosPricetag /> Crea tu cuenta de tutor por <strong>4,99€</strong>/mes</h3>
                </div>
            </div>
        </div>
    </div>
  </PaginaEstatica>
);

export const ContactaConNosotros = () => (
  <PaginaEstatica>
    <div className="principalEstatico">
        <h1>Contacta con Nosotros</h1>
        <p>Para enviarnos un mensaje, por favor regístrate o inicia sesión.</p>
        <p>Si prefieres, puedes escribirnos directamente al correo <a style={{color: 'var(--enlace)'}} href="mailto:app.formacioncorreo@gmail.com">app.formacioncorreo@gmail.com</a> y te responderemos en menos de 24 horas.</p>

        <p>Tus datos solo se usarán para gestionar tu consulta y no compartiremos tu correo con terceros.</p>
    </div>
  </PaginaEstatica>
);

export const Terminos = () => (
  <PaginaEstatica>
    <div className="principalEstatico">
        <h1>Términos y condiciones</h1>
        <ol>
            <li><strong>Objeto:</strong> App-Formación ofrece acceso online a cursos y clases a través de esta plataforma.</li>
            <li><strong>Registro y cuenta de usuario:</strong> El usuario se compromete a aportar datos veraces. Nos reservamos el derecho de suspender cuentas en caso de incumplimiento.</li>
            <li><strong>Propiedad intelectual:</strong> Todo el material (vídeos, textos, ejercicios) está protegido y su uso es exclusivamente personal.</li>
            <li><strong>Pagos y suscripciones:</strong> Métodos aceptados: tarjeta y suscripciones. Cancelaciones y reembolsos según nuestra política de devoluciones.</li>
            <li><strong>Limitación de responsabilidad:</strong> App-Formación no se hace responsable de interrupciones ajenas (internet, mantenimiento). No garantizamos resultados académicos ni empleo tras el curso.</li>
            <li><strong>Modificaciones:</strong> Nos reservamos el derecho a actualizar precios, contenidos y condiciones previa notificación.</li>
            <li><strong>Ley aplicable y jurisdicción:</strong> Estos términos se rigen por la legislación española y cualquier disputa se someterá a los juzgados españoles.</li>
        </ol>
    </div>
  </PaginaEstatica>
);

export const Privacidad = () => (
  <PaginaEstatica>
    <div className="principalEstatico">
        <h1>Privacidad</h1>
        <span><strong>Responsable:</strong> App-Formación – Av. Universidad de Cádiz, 10, 11519 Puerto Real, Cádiz</span>
        <h2>Datos que recogemos</h2>
        <ul>
        <li>Nombre, email y contraseña (registro).</li>
        <li>Historial de cursos y progreso.</li>
        <li>Datos de pago (gestionados por pasarela PCI, no almacenamos números completos).</li>
        </ul>

        <h2>Finalidades</h2>
        <ul>
        <li>Crear y gestionar tu cuenta.</li>
        <li>Procesar pagos y facturación.</li>
        <li>Mejorar el servicio y enviarte comunicaciones importantes.</li>
        </ul>

        <h2>Conservación</h2>
        <ul>
        <li>Datos de facturación: 5 años (obligación legal).</li>
        <li>Otra información: mientras dure tu cuenta activa.</li>
        </ul>

        <h2>Derechos</h2>
        <p>Puedes ejercer tus derechos de acceso, rectificación, supresión, limitación, portabilidad y oposición escribiendo a <a style={{color: 'var(--enlace)'}} href="mailto:app.formacioncorreo@gmail.com">app.formacioncorreo@gmail.com</a>.</p>

        <h2>Medidas de seguridad</h2>
        <p>Conexiones cifradas (HTTPS/TLS) y contraseñas hasheadas con bcrypt.</p>
    </div>
  </PaginaEstatica>
);

export const Seguridad = () => (
  <PaginaEstatica>
    <div className="principalEstatico">
        <h1>Seguridad</h1>
        <ul>
            <li><strong>Cifrado SSL/TLS:</strong> todas las comunicaciones están protegidas.</li>
            <li><strong>Contraseñas seguras:</strong> almacenadas con bcrypt y políticas de complejidad.</li>
            <li><strong>Copias de seguridad diarias</strong> y redundancia en servidores en la nube.</li>
            <li><strong>Monitoreo y auditoría</strong> según buenas prácticas OWASP.</li>
            <li><strong>Notificación de incidentes:</strong> te informaremos en un plazo máximo de 72 horas si hubiera alguna brecha.</li>
            <li><strong>Protección de Datos:</strong> Mantenemos el anonimato ocultando datos como su correo, tan solo se usará el nombre de Usuario, además del nombre y apelliodos en la aplicación.</li>
        </ul>
    </div>
  </PaginaEstatica>
);

export const Cookies = () => (
  <PaginaEstatica>
    <div className="principalEstatico">
        <h1>Declaración de Cookies</h1>
        <ul>
            <li>No utilizamos cookies propias.</li>
            <li>Usamos <strong>Almacenamiento en el navegador</strong> para el almacenamiento de datos que mejoran la experiencia al usar la aplicación </li>
            <li>Cookies de terceros: empleadas únicamente por servicios externos como pasarelas de pago o Google Fonts.</li>
        </ul>

        <h2>Gestión de cookies</h2>
        <p>Puedes desactivar o eliminar cookies desde la configuración de tu navegador (Chrome, Firefox, Safari, etc.).</p>
        <p>Para cualquier duda sobre cookies o tratamiento de datos, contáctanos en <a href="mailto:app.formacioncorreo@gmail.com">app.formacioncorreo@gmail.com</a>.</p>
    </div>
  </PaginaEstatica>
);

const Footer=() => {

     const [usuario, setUsuario] = useState(() => {
        const usuarioAlmacenado = localStorage.getItem("userLogueado");
        return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
    })

    
    const [compose, setCompose] = useState({ abierto: false, inicial: {} });

    useEffect(() => {
        $(".footer").hide().slideDown(600);
        return () => {
        $(".footer").stop(true, true).show();
        };
    }, []);

    return (
        <div className="footer">
            <div className="sb_footer section_padding">
                <div className="sb_footer-links">
                    <div className="sb_footer-links_div">
                        <h4>Informática</h4>
                        <Link 
                            to={{ pathname: "/Contenido", state: { filtro_inicial: "tematicas", tematicas_inicial: "Informática" } }} 
                            smooth
                            duration={500}
                        >
                            <p>Informática</p>
                        </Link>
                        <Link 
                            to={{ pathname: "/Contenido", state: { filtro_inicial: "tematicas", tematicas_inicial: "Programación" } }} 
                            smooth
                            duration={500}
                        >
                            <p>Programación</p>
                        </Link>
                        <Link 
                            to={{ pathname: "/Contenido", state: { filtro_inicial: "tematicas", tematicas_inicial: "IA" } }} 
                            smooth
                            duration={500}
                        >
                            <p>IA</p>
                        </Link>
                    </div>
                    <div className="sb_footer-links_div">
                        <h4>Economía</h4>
                        <Link 
                            to={{ pathname: "/Contenido", state: { filtro_inicial: "tematicas", tematicas_inicial: "Economía" } }} 
                            smooth
                            duration={500}
                        >
                            <p>Economía</p>
                        </Link>
                        <Link 
                            to={{ pathname: "/Contenido", state: { filtro_inicial: "tematicas", tematicas_inicial: "Finanzas" } }} 
                            smooth
                            duration={500}
                        >
                            <p>Finanzas</p>
                        </Link>
                        <Link 
                            to={{ pathname: "/Contenido", state: { filtro_inicial: "tematicas", tematicas_inicial: "Emprendimiento" } }} 
                            smooth
                            duration={500}
                        >
                            <p>Emprendimiento</p>
                        </Link>
                    </div>
                    <div className="sb_footer-links_div">
                        <h4>Contenido</h4>
                        <Link to={{ pathname: "/Contenido", state: { filtro_inicial: "clases" } }}>
                            <p>Clases</p>
                        </Link>
                        <Link to={{ pathname: "/Contenido", state: { filtro_inicial: "cursos" } }}>
                            <p>Cursos</p>
                        </Link>
                        <Link to={{ pathname: "/Tutores" }}>
                            <p>Tutores</p>
                        </Link>
                    </div>
                    <div className="sb_footer-links_div">
                        <h4>Acerca de</h4>
                        <Link to="/quienes-somos">
                            <p>¿Quiénes somos?</p>
                        </Link>
                        <Link to="/planesPrecios">
                            <p>Planes y precios</p>
                        </Link>
                        {usuario ? 
                            (   
                                <Link onClick={() => {
                                    const administracion = "Administrador"
                                    
                                    setCompose({
                                        abierto: true,
                                            inicial: {
                                                Destinatarios: administracion,
                                                Asunto: "",
                                                Contenido: "",
                                                Archivo: null,
                                                respuestaA: false,
                                                leerSoloDestinatarios: true,
                                                leerSoloAsunto: false,
                                            },
                                        });

                                        setTimeout(() => {
                                            Swal.fire({
                                                icon: 'info',
                                                title: '¿Necesitas ayuda?',
                                                text: '¿Tienes preguntas, sugerencias o necesitas ayuda? Rellena este breve formulario y nuestro equipo de soporte te atenderá en menos de 24 horas.',
                                                confirmButtonText: 'Entendido',
                                            });
                                        }, 100);
                                    }}>
                                    <p>Contacta con nosotros</p>
                                </Link>
                                
                            ) 
                            : (
                               <Link to="/contacta">
                                    <p>Contacta con nosotros</p>
                                </Link> 
                            )
                        }
                        <ComponerMensajeDialog
                            abierto={compose.abierto}
                            inicial={compose.inicial}
                            onClose={() => setCompose({ abierto: false, inicial: {} })}
                        />
                    </div>
                    <div className="sb_footer-links_div">
                        <h4>Próximamente en:</h4>
                        <div className="socialmedia">
                            <p><TiSocialFacebookCircular style={{ fontSize: '40px' }} /></p>
                            <p><RiTwitterXFill style={{ fontSize: '40px' }}/></p>
                            <p><FaInstagram style={{ fontSize: '40px' }}/></p>
                        </div>
                        <h4>Métodos de pago:</h4>
                        <div className="metodosPago">
                            <p><FaCcMastercard style={{ fontSize: '40px' }}/></p>
                            <p><FaCcPaypal style={{ fontSize: '40px' }}/></p>
                            <p><RiVisaFill style={{ fontSize: '40px' }}/></p>
                        </div>
                    </div>
                </div>
                <hr></hr>
                <div className="sb_footer-below">
                    <div className="sb_footer-copyright">
                        <p>
                            @{new Date().getFullYear()} App-Formación. Todos los derechos reservados
                        </p>
                    </div>
                    <div className="sb_footer-below-links">
                        <Link to="/terminos"><div><p>Términos y condiciones</p></div></Link>  
                        <Link to="/privacidad"><div><p>Privacidad</p></div></Link>  
                        <Link to="/seguridad"><div><p>Seguridad</p></div></Link>  
                        <Link to="/cookies"><div><p>Declaración de cookies</p></div></Link>     
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;